import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { moveToSpam } from '../../actions/chatOperations';
import { trackClickMoveToSpam } from '../../actions/userCard/tracking';
import { UserCardDesktopBlockedChat } from '../../components/UserCard/UserCardDesktopBlockedChat';
import { useCurrentChatCompanionData } from '../../hooks';
import { currentChatOpponentIdSelector, currentOpenChatSelector } from '../../selectors';

export const UserCardBlockChatContainer = () => {
  const dispatch = useDispatch();

  const currentChat = useSelector(currentOpenChatSelector);
  const opponentId = useSelector(currentChatOpponentIdSelector);

  const { companionId } = useCurrentChatCompanionData(currentChat?.chatId);

  const isChatBlockingAvailable =
    currentChat && currentChat.availableActions
      ? currentChat.availableActions.indexOf('block') !== -1 && !currentChat.blocked
      : false;

  if (!currentChat || !companionId || !isChatBlockingAvailable) {
    return null;
  }

  const handleClickSpam = () => {
    dispatch(moveToSpam(currentChat.chatId));
    trackClickMoveToSpam(currentChat, companionId, opponentId);
  };

  return <UserCardDesktopBlockedChat handleClickSpam={handleClickSpam} />;
};
